import {ReactNode, useEffect} from 'react';
import {Order} from '../../models/order';
import {useOrderStore} from '../../store/orderStore';
import {useAuthStore} from '../../store/authStore';

interface OrderProviderProps {
    children: (order: Order | null) => ReactNode | ReactNode[];
}

const OrderProvider = ({children}: OrderProviderProps) => {
    const {order, fetchOrder, isLoading} = useOrderStore(state => state);
    const {bearer, setInvalidBearer} = useAuthStore(state => state);

    useEffect(() => {
        if (!bearer || order || isLoading) {
            return;
        }
        fetchOrder(bearer, setInvalidBearer);
    }, [bearer, order, isLoading, fetchOrder, setInvalidBearer]);

    return <>{children(order)}</>;
};

export default OrderProvider;
